enum EApigeeLabelTypes {
  FETCH_APIGEE_LABEL = 'ApigeeLabel/FETCH_APIGEE_LABEL',
  FETCH_APIGEE_LABEL_SUCCESS = 'ApigeeLabel/FETCH_APIGEE_LABEL_SUCCESS',
  FETCH_APIGEE_LABEL_ERROR = 'ApigeeLabel/FETCH_APIGEE_LABEL_ERROR',
  FETCH_APIGEE_LABEL_START = 'ApigeeLabel/FETCH_APIGEE_LABEL_START',
  FETCH_APIGEE_LABEL_END = 'ApigeeLabel/FETCH_APIGEE_LABEL_END',
}

export default EApigeeLabelTypes;
